import { render, staticRenderFns } from "./deliveryset.vue?vue&type=template&id=2d551c26&scoped=true"
import script from "./deliveryset.vue?vue&type=script&lang=js"
export * from "./deliveryset.vue?vue&type=script&lang=js"
import style0 from "./deliveryset.vue?vue&type=style&index=0&id=2d551c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d551c26",
  null
  
)

export default component.exports